module.exports = __webpack_public_path__ + "static/media/AwsDemo-2015.d62c095f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AwsDemo-2015.png
// module id = 84
// module chunks = 0